module.exports = __webpack_public_path__ + "img/_ic_star_75.7d3eadc3.svg";